export default [
	[
		{
			index: 'created_at',
			header: {
				title: 'created at',
				rowSpan: 2
			}
		},
		{
			index: 'sent_at',
			header: {
				title: 'sent at',
				rowSpan: 2
			}
		},
		{
			index: 'language',
			header: {
				title: 'lang',
				rowSpan: 2
			}
		},
		{
			index: 'title',
			header: {
				title: 'title',
				rowSpan: 2
			}
		},
		{
			index: 'id',
			header: {
				title: 'id',
				rowSpan: 2
			}
		},
		{
			index: 'reach',
			header: {
				title: 'reach',
				rowSpan: 2
			}
		},
		{
			index: 'events',
			header: {
				title: 'events',
				colSpan: 4
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions',
				rowSpan: 2
			}
		}
	],
	[
		{
			index: 'open',
			header: {
				title: 'open'
			}
		},
		{
			index: 'click',
			header: {
				title: 'click'
			}
		},
		{
			index: 'bounce',
			header: {
				title: 'bounce'
			}
		},
		{
			index: 'unsubs',
			header: {
				title: 'unsubs'
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/manual-mailings/list/headers.js